import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../utils';
import { Text } from '../typography';
export function FormSteps({ steps, getCurrentStep }) {
    const currentStepIndex = getCurrentStep().index;
    return (_jsx("div", { className: "flex gap-stack-roomy w-full px-stack-section", children: steps.map(({ label }, key) => {
            const isCurrentStep = key === currentStepIndex;
            const isActiveOrDoneStep = key <= currentStepIndex;
            return (_jsxs("div", { className: cn('transition-all duration-control flex flex-col', 'md:w-full', isCurrentStep ? 'w-full' : 'w-6', 'h-10'), children: [isCurrentStep && (_jsx(Text, { className: cn('py-stack-dense w-full text-fg-link text-left flex flex-col gap-stack-tight text-body-sm text-nowrap transition-colors duration-panel'), children: label })), _jsx("div", { className: cn('h-1.5 rounded-pill transition-all duration-control mt-auto', 'md:w-full', isCurrentStep ? 'w-full' : 'w-6', {
                            'bg-brand': isActiveOrDoneStep,
                            'bg-border': !isActiveOrDoneStep,
                        }) })] }, key));
        }) }));
}
